import { BaseMapper } from '@ps/utils';
import { SurveySupplierCpi } from '@ps/survey-utils';

import { SurveySupplierCpiDto } from '../dtos/survey-supplier-cpi.dto';

export class SurveySupplierCpiMapper extends BaseMapper<
  SurveySupplierCpiDto,
  SurveySupplierCpi
> {
  public fromDto(dto: SurveySupplierCpiDto): SurveySupplierCpi {
    const name = dto.group_ref
      ? dto.group_name
      : (dto.suppliers[0]?.name ?? dto.group_name);
    return {
      name,
      cpi: dto.cpi,
      isPdsApplied: dto.is_pds_applied,
      fee: dto.fee,
    };
  }
}
